<template>
  <b-button 
    variant="primary" 
    disabled
    class="w-100" 
    @click="$emit('click')" 
    v-b-tooltip.hover 
    title="Processar débito da conta">
    Débito
  </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue';

export default {
  name: 'DebitButton',
  components: { BButton },
};
</script>
